import { connect } from 'react-redux';
import { SelectedStateView } from './SelectedStateView';
import { openDropdown } from '../../../data/dropdown-state/dropdownStateActions';
import dropdownStateSelector from '../../../data/dropdown-state/dropdownStateSelector';

export function mapStateToProps(state) {
    const dropdownState = dropdownStateSelector(state);
    const carrierName = dropdownState.carrier ? dropdownState.carrier.name : null;
    const planName = carrierName && parseInt(dropdownState.carrier.id, 10) > 0 && dropdownState.plan
        ? dropdownState.plan.name
        : null;
    return {
        carrierName,
        planName,
    };
}

export const mapDispatchToProps = {
    openDropdown,
};

export const SelectedStateConnector = connect(
    mapStateToProps,
    mapDispatchToProps
)(SelectedStateView);
